module.exports = __webpack_public_path__ + "static/img/distribution_system1.d53cdc74.jpg";